var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0 pb-12",attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{staticClass:"d-flex",attrs:{"cols":"12"}},[_c('client-list',_vm._b({},'client-list',_vm.paginationStateFromRoute,false))],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }